export type QRiskStatus =
  | 'pending'
  | 'test_failed'
  | 'success'
  | 'age_or_heart_disease'
  | 'qrisk_failed'
  | 'time_exceeded'
  // new QRisk statuses
  | 'postcode_failed'
  | 'validation_failed'
  | 'not_calculated';

export type QRiskProps = {
  score10Year: string | null;
  scoreHealthy: string | null;
  heartAge: string | null;
  publishedScore10Year?: string | null;
  publishedScoreHealthy?: string | null;
  publishedHeartAge?: string | null;
  status: QRiskStatus | null | undefined;
  resultStatus: string;
};

export const validationFailedTitle = 'QRISK can only be calculated for users:';

export const validationFailedBulletPoints = [
  'Aged 25-84',
  'With a BMI between 15-47',
  'Not previously diagnosed with a cardiovascular event (e.g. heart attack, stroke, angina)',
  'Not type 1 diabetic',
];

/**
 * Defines info messages that are to be presented for respective QRisk statuses
 */
export const qRiskStatusInfoMessages: Map<QRiskStatus, string | null> = new Map([
  ['pending', null],
  [
    'test_failed',
    'This QRISK score has been calculated without cholesterol values. To create a more accurate QRISK score, please perform another PocDoc Lipid test.',
  ],
  ['success', null],
  [
    'age_or_heart_disease',
    'QRISK can only be calculated for users aged 25-84 who have not been previously diagnosed with coronary heart disease (including angina or heart attack), stroke/transient ischemic attack or type 1 diabetes.',
  ],
  [
    'qrisk_failed',
    'There was an issue calculating your QRISK and we were unable to produce a result.',
  ],
  ['time_exceeded', 'We have been unable to calculate your QRISK as the timer was exceeded.'],

  // new QRisk statuses
  ['not_calculated', null],
  ['validation_failed', null],
  [
    'postcode_failed',
    'We could not calculate your QRISK because we were unable to validate your postcode.',
  ],
]);
